import { BidTypes } from '../bid/types'
import { Deal } from './types'

export const getDealBid = (deal: Deal, bidType: BidTypes) => deal[`${bidType}_bid`]

export const getDealPrice = (deal: Deal, bidType: BidTypes) => deal[`${bidType}_price`]

export const isDealClosed = (deal: Deal) => Boolean(deal.closed_at)
export const isDealOpen = (deal: Deal) => !isDealClosed(deal)
